module.exports = __webpack_public_path__ + "img/4.779b9b2d.png";